import { I18n } from "@assets/strings";
import React from "react";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { useSuggestedArticles } from "@domain/lms/article/hooks";
import { useIsMobile } from "@utils/hooks";
import { ArticleThumbnailSmall } from "@ui/components/article/articleThumbnailSmall";
import { Carousel } from "@ui/components/carousel/carousel";

type FeedArticleSuggestionsProps = React.HTMLAttributes<HTMLDivElement>;
export const FeedArticleSuggestions: React.FC<FeedArticleSuggestionsProps> = ({ ...htmlProps }) => {
	const { result: articles, loading } = useSuggestedArticles(10, undefined);
	const currentProfile = useCurrentProfile();
	const proposedArticles = articles.filter((art) => art.author?.id !== currentProfile?.id);
	const isMobile = useIsMobile();

	return (
		<Carousel
			{...htmlProps}
			//forceArrows
			style={{ marginTop: 20 }}
			items={proposedArticles ? (proposedArticles.length > 3 ? proposedArticles.slice(0, 3) : proposedArticles) : []}
			renderItem={(article) => <ArticleThumbnailSmall key={article.id} article={article} />}
			title={I18n.t("article.suggestions")}
			loading={loading}
			itemHeight={isMobile ? 470 : 450}
			itemWidth={310}
		/>
	);
};
